import axios from 'axios'

// create an axios instance
const service = axios.create({
  // baseURL: process.env.BASE_URL,
  //withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // 默认设置为POST请求
    if (!config.method) {
      config.method = 'post'
    }
    config.headers = {
      "Content-Type": "application/json; charset=utf-8",
      "YX-ENC": 0,
      "YX-CC": "sis5b35e1ac2fc1bL9pQ4GSLoCsBY7GG",
      "YX-Timestamp": +new Date(),
      "YX-SESSION": "",
      "YX-Channel": "Dev",
      "YX-Source": "web",
      "YX-Device": "iPhone7,2",
      "YX-IMEI": "959042586bb0e33bdd2c02db47425ea254ab1238",
      "YX-Jailbroken": 0,
      "YX-Language": "zh-Hans-CN",
      "YX-MobileModel": "iPhone",
      "YX-OsVersion": "10.3.3",
      "YX-Platform": "iPhone",
      "YX-Region": "CN",
      "YX-Screen": "750X1334",
      "YX-Simulator": 0,
      "YX-Version": 602,
      "YX-VersionName": "3.0.0",
      "YX-encrypt": 0,
      "ad-idfa": "97C7F1DF-5C56-478D-8863-0E93CDAF6B2F",
      "ad-ip": "",
      "ad-mac": "02:00:00:00:00:00",
      "ad-openuuid": "959042586bb0e33bdd2c02db47425ea254ab1238",
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error)
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    if (response.config.url && response.config.url.includes('staticProtocol/getContentById') > 0) {
      return response.data
    }
    const res = response.data

    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 0) {
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js